// 64 is the char code for the first alphabet, i.e. a, 65 for b, and so on.
const CHAR_CODE_FOR_FIRST_ALPHABET = 64;

export default function characterFromNumber(n = 1) {
  if (!Number.isInteger(n)) {
    throw new Error('[character-from-number] You must pass an integer');
  }

  return String.fromCharCode(CHAR_CODE_FOR_FIRST_ALPHABET + n);
}
